import "./abstract-base-CdeHT0x1.js";
import { e as b } from "./query-Brcoqn5X.js";
import { e as S } from "./base-D76d76ww.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let m;
function d(e) {
  return (r, t) => S(r, t, { get() {
    var u;
    return ((u = this.renderRoot) != null ? u : m != null ? m : m = document.createDocumentFragment()).querySelectorAll(e);
  } });
}
const f = ({
  finisher: e,
  descriptor: r
}) => (t, u) => {
  var n;
  if (u !== void 0) {
    const a = t.constructor;
    r !== void 0 && Object.defineProperty(t, u, r(u)), e == null || e(a, u);
  } else {
    const a = (n = t.originalKey) != null ? n : t.key, l = r !== void 0 ? {
      kind: "method",
      placement: "prototype",
      key: a,
      descriptor: r(t.key)
    } : { ...t, key: a };
    return e && (l.finisher = function(s) {
      e(s, a);
    }), l;
  }
};
function c(e, r, t = {}, u = !1) {
  var l;
  const n = `slot${r ? `[name=${r}]` : ":not([name])"}`, a = (l = e.renderRoot) == null ? void 0 : l.querySelector(n);
  return a ? u ? a.assignedNodes(t).filter((s) => s.nodeType !== Node.COMMENT_NODE) : a.assignedElements(t) : [];
}
function y(e) {
  return typeof e == "string" ? { version: e } : e.alternateSlot !== void 0 && e.alternateSlot !== null ? {
    alternateSlot: e.alternateSlot,
    version: e.version
  } : {
    alternateAttribute: e.alternateAttribute,
    version: e.version
  };
}
function A(e, r = !1) {
  const { slot: t, selector: u, deprecated: n, flatten: a } = e != null ? e : {};
  let l;
  return n && (l = y(n)), f({
    descriptor: (s) => ({
      get() {
        let o = c(this, t, { flatten: a });
        return o.length === 0 && n && l && l.alternateSlot && (o = c(this, l.alternateSlot, {
          flatten: a
        })), u ? o == null ? void 0 : o.filter((i) => {
          var g;
          return r ? ((g = i == null ? void 0 : i.nodeName) == null ? void 0 : g.toLowerCase()) === this.getScopedTagName(u) : i.matches(u);
        }) : o;
      },
      set() {
        if (n) {
          const o = t != null ? t : "";
          this.alternateSlots.set(o, l);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function q(e) {
  return function(r, t) {
    return b(e)(r, t);
  };
}
function C(e, r) {
  return f({
    descriptor: (t) => ({
      get() {
        var n;
        return (n = this.querySelector(e)) != null ? n : null;
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function E({ slot: e, defaultValue: r }) {
  return f({
    descriptor: (t) => ({
      get() {
        var a, l, s;
        const n = c(this, e)[0];
        return (s = (l = (a = n == null ? void 0 : n.textContent) == null ? void 0 : a.trim()) != null ? l : r) != null ? s : "";
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function _(e) {
  return function(r, t) {
    return d(e)(r, t);
  };
}
function k(e) {
  const { slot: r, deprecated: t, flatten: u } = e != null ? e : {};
  let n;
  return t && (n = y(t)), f({
    descriptor: (a) => ({
      get() {
        let l = c(this, r, { flatten: u }, !0);
        return l.length === 0 && t && n && n.alternateSlot && (l = c(
          this,
          n.alternateSlot,
          { flatten: u },
          !0
        )), l;
      },
      set() {
        if (t) {
          const l = r != null ? r : "";
          this.alternateSlots.set(l, n);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
export {
  A as a,
  q as b,
  k as c,
  _ as d,
  C as q,
  d as r,
  E as s
};
